import Nav from "./Nav"

const Contact = () => {
    return (
        <>
        <Nav />
        <div className="contact">
            <h1>dora</h1>
            <div className="contact--info">
                <p>123 Michealson Drive, Singapore 987654</p>
                <p>Phone: (+65)123 456, 456 789</p>
                <p>Email: info@wonderland.com</p>
            </div>
        </div>
        </>
    )
}

export default Contact